import supabase from "../supabase";

const API = "https://fta-backend-javascript.onrender.com"; 
// ^^ replace with your backend URL (no /AuthController anymore)

// Helper: attach JWT to all requests
async function authHeaders() {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error("No active session");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${session.access_token}`,
  };
}

// ------------------------------
// GET ONE MEMBER
// ------------------------------
export async function getMember(id) {
  const headers = await authHeaders();

  const res = await fetch(`${API}/members/${id}`, { headers });
  if (!res.ok) throw new Error("Failed to fetch member");
  return res.json();
}

// ------------------------------
// GET ALL MEMBERS (for this user only)
// ------------------------------
export async function getMembers() {
  const headers = await authHeaders();

  const res = await fetch(`${API}/members`, { headers });
  if (!res.ok) throw new Error("Failed to fetch members");
  return res.json();
}

// ------------------------------
// ADD MEMBER
// ------------------------------
export async function addMember(data) {
  const headers = await authHeaders();

  const res = await fetch(`${API}/members`, {
    method: "POST",
    headers,
    body: JSON.stringify(data),
  });

  if (!res.ok) throw new Error("Failed to add member");
  return res.json();
}

// ------------------------------
// UPDATE MEMBER
// ------------------------------
export async function updateMember(id, data) {
  const headers = await authHeaders();

  const res = await fetch(`${API}/members/${id}`, {
    method: "PUT",
    headers,
    body: JSON.stringify(data),
  });

  if (!res.ok) throw new Error("Failed to update member");
  return res.json();
}

// ------------------------------
// DELETE MEMBER
// ------------------------------
export async function deleteMember(id) {
  const headers = await authHeaders();

  const res = await fetch(`${API}/members/${id}`, {
    method: "DELETE",
    headers,
  });

  if (!res.ok) throw new Error("Failed to delete member");
  return true;
}

// ------------------------------
// ADD MEMORY
// ------------------------------
export async function addMemory(id, data) {
  const headers = await authHeaders();

  const res = await fetch(`${API}/members/${id}/memories`, {
    method: "POST",
    headers,
    body: JSON.stringify(data),
  });

  if (!res.ok) throw new Error("Failed to add memory");
  return res.json();
}

// ------------------------------
// ADD PARENT
// ------------------------------
export async function addParentAPI(childId, parentId) {
  const headers = await authHeaders();

  const res = await fetch(`${API}/members/${childId}/add-parent/${parentId}`, {
    method: "POST",
    headers,
  });

  if (!res.ok) throw new Error("Failed to add parent");
  return res.json();
}

// ------------------------------
// ADD CHILD
// ------------------------------
export async function addChildAPI(parentId, childId) {
  const headers = await authHeaders();

  const res = await fetch(`${API}/members/${parentId}/add-child/${childId}`, {
    method: "POST",
    headers,
  });

  if (!res.ok) throw new Error("Failed to add child");
  return res.json();
}
